import React from 'react';
import { PictoProps } from '../index';

export const Bed = (props: PictoProps) => (
  <svg
    width={props.width || '36'}
    height={props.height || '20'}
    viewBox="0 0 36 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.72222 7.2C6.72222 5.44 8.12222 4 9.83333 4C11.5444 4 12.9444 5.44 12.9444 7.2C12.9444 8.96 11.5444 10.4 9.83333 10.4C8.12222 10.4 6.72222 8.96 6.72222 7.2ZM34.7222 12H5.16667V0.8C5.16667 0.36 4.81667 0 4.38889 0H1.27778C0.85 0 0.5 0.36 0.5 0.8V20H5.16667V16.8H30.8333V20H35.5V12.8C35.5 12.36 35.15 12 34.7222 12ZM29.2778 4.8H15.2778C14.85 4.8 14.5 5.16 14.5 5.6V10.4H34.7222C34.7222 7.32 32.2722 4.8 29.2778 4.8Z"
      fill={props.fill || 'var(--travelPlanerPrimaryColor)'}
    />
  </svg>
);
